import React from 'react';
import moment from 'moment';
import Datetime from 'react-datetime';
import MenuTree from './MenuTree.jsx';
import { valueForKeyPath as v } from '../../../utils.jsx';
import MediaBrowserService from './mediaBrowser/MediaBrowserService.jsx';
require('react-datetime/css/react-datetime.css');

var cx = require('classnames');

const ArticlePublicationFormModalDialog = props => {
  return (
    <div>
      <div className="modal fade in" style={{ display: 'block' }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={props.onClose}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 className="modal-title">{props.title}</h4>
            </div>
            <div className="modal-body">{props.children}</div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

class ArticlePublicationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      article: this.props.article || {},
      assignDialogShow: false,
    };

    this.articleShouldRemove = this.articleShouldRemove.bind(this);
    this.dateDidChange = this.dateDidChange.bind(this);
    this.articlePublishedChange = this.articlePublishedChange.bind(this);
    this.articleLockedChange = this.articleLockedChange.bind(this);
    this.urlDidChange = this.urlDidChange.bind(this);
    this.pinDidChange = this.pinDidChange.bind(this);
    this.authorNameDidChange = this.authorNameDidChange.bind(this);
    this.pushNotificationDidChange = this.pushNotificationDidChange.bind(this);
    this.openMediaBrowserAuthorPicture = this.openMediaBrowserAuthorPicture.bind(
      this,
    );
    this.removeAuthorPicture = this.removeAuthorPicture.bind(this);
  }

  articleShouldRemove() {
    if (window.confirm('Odstrániť článok?')) {
      this.props.articleDidRemove(this.props.article._id);
    }
  }

  dateDidChange(date) {
    let a = this.props.article;
    a['date'] = date;
    this.props.articleDidUpdate(a);
  }

  urlDidChange(evt) {
    let a = this.props.article;
    let url = evt.target.value;
    url = url.replace(/^\/+(.+)$/g, '$1');
    url = url.replace(/[^a-zA-Z0-9\-\/]/g, '');
    url = url.replace(/\/\//g, '/');
    a['url'] = url;
    this.props.articleDidUpdate(a);
  }

  pinDidChange(evt) {
    let a = this.props.article;
    let v = evt.target.value;
    v = v.replace(/^\/[^0-9]+/g, '');
    a[evt.target.name] = parseInt(v);
    this.props.articleDidUpdate(a);
  }

  pushNotificationDidChange(e) {
    let a = this.props.article;
    a['push_notification'] = e.target.checked;
    this.props.articleDidUpdate(a);
  }

  articlePublishedChange(e) {
    let a = this.props.article;
    a['published'] = e.target.checked;
    this.props.articleDidUpdate(a);
  }

  articleLockedChange(e) {
    let a = this.props.article;
    a['locked'] = e.target.checked;
    this.props.articleDidUpdate(a);
  }

  onAssignClick() {
    this.setState({ assignDialogShow: true });
  }

  closeDialog() {
    this.setState({ assignDialogShow: false });
  }

  onItemToggleOpen(item) {
    this.props.reloadSections(item._id);
  }

  onTreeMenuSelectItem(section) {
    let a = this.props.article;
    a['sectionid'] = section._id;
    this.props.articleDidUpdate(a);
    this.props.sectionDidUpdate(section);
    this.setState({ assignDialogShow: false });
  }

  onSectionRootSelect() {
    let a = this.props.article;
    a['sectionid'] = null;
    this.props.articleDidUpdate(a);
    this.props.sectionDidUpdate({});
    this.setState({ assignDialogShow: false });
  }

  openMediaBrowserAuthorPicture() {
    var onFileSelect = uri => {
      MediaBrowserService.closeMediaBrowser();
      this.authorPictureDidChange(uri);
    };
    MediaBrowserService.openMediaBrowser(
      onFileSelect,
      null,
      this.props.mediaManager,
      false,
    );
  }

  removeAuthorPicture() {
    this.authorPictureDidChange(null);
  }

  authorPictureDidChange(picture) {
    let a = this.props.article;
    if (!a.author) {
      a.author = {};
    }
    a.author.picture = picture;
    this.props.articleDidUpdate(a);
  }

  authorNameDidChange(evt) {
    let a = this.props.article;
    if (!a.author) {
      a.author = {};
    }
    a.author.name = evt.target.value;
    this.props.articleDidUpdate(a);
  }

  render() {
    if (this.props.cid) {
      return (
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Publikácia</h3>
          </div>
          <div className="panel-body">
            <div className="form-group">
              <div className="row">
                {this.props.article._id ? (
                  <div className="col-xs-6">
                    <button
                      onClick={this.props.onDeleteStaticTextContent}
                      className="btn btn-danger btn-block"
                    >
                      <i className="fa fa-trash" /> Odstrániť
                    </button>
                  </div>
                ) : null}
                <div className={`col-xs-${this.props.article._id ? 6 : 12}`}>
                  <button
                    onClick={this.props.onUpdateStaticTextContent}
                    className="btn btn-success btn-block"
                  >
                    <i className="fa fa-floppy-o" /> Uložiť
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.props.sectionId) {
      return (
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">Publikácia</h3>
          </div>
          <div className="panel-body">
            <div className="form-group">
              <div className="row">
                {this.props.article._id ? (
                  <div className="col-xs-6">
                    <button
                      onClick={this.props.onDeleteSectionContent}
                      className="btn btn-danger btn-block"
                    >
                      <i className="fa fa-trash" /> Odstrániť
                    </button>
                  </div>
                ) : null}
                <div className={`col-xs-${this.props.article._id ? 6 : 12}`}>
                  <button
                    onClick={this.props.onUpdateSectionContent}
                    className="btn btn-success btn-block"
                  >
                    <i className="fa fa-floppy-o" /> Uložiť
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      let sectionForm = <div />;
      let isNew = true;
      if (!this.props.article._id) {
        isNew = false;
      }

      let assignToSectionForm = (
        <div className="form-group">
          <label className="title">Aktuálna rubrika</label>
          <button
            onClick={this.onAssignClick.bind(this)}
            className={cx('btn btn-block btn-ellipsis', {
              'btn-success': this.props.section._id,
              'btn-default': !this.props.section._id,
            })}
            disabled={
              this.props.article.locked &&
              !this.props.contentspace_info.is_contentspace_admin
                ? 'disabled'
                : ''
            }
          >
            {this.props.sectionIsLoading
              ? [<i key="m1" className="fa fa-refresh fa-spin" />, ' ']
              : this.props.section._id
                ? this.props.section.name
                : 'nezaradený'}
          </button>
        </div>
      );

      if (!isNew || true) {
        let dialog;
        if (this.state.assignDialogShow) {
          let title = 'Zaradenie do inej rubriky';
          dialog = (
            <ArticlePublicationFormModalDialog
              title={title}
              onClose={this.closeDialog.bind(this)}
            >
              <a
                href="javascript:void(0);"
                onClick={this.onSectionRootSelect.bind(this)}
                data-id="0"
              >
                <strong>Žiadna sekcia</strong>
              </a>
              <MenuTree
                showButtons={false}
                onItemToggleOpen={this.onItemToggleOpen.bind(this)}
                onItemClick={this.onTreeMenuSelectItem.bind(this)}
                tree={this.props.sections}
              />
            </ArticlePublicationFormModalDialog>
          );
        }
        sectionForm = (
          <div>
            <div key="men" className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">Menu</h3>
              </div>
              <div className="panel-body">{assignToSectionForm}</div>
            </div>
            {dialog}
          </div>
        );
      }

      return (
        <div key="par">
          <div key="pub" className="panel panel-default">
            <div className="panel-heading">
              <h3 className="panel-title">Publikácia</h3>
            </div>
            <div className="panel-body">
              <div className="form-group">
                <label className="title">Dátum vytvorenia</label>
                <br />
                {moment(v(this.props.article, 'created', new Date())).format(
                  'LLL',
                )}
              </div>
              <div className="form-group">
                <label className="title">Publikovať od</label>
                <br />
                <Datetime
                  value={
                    this.props.article.date
                      ? moment(this.props.article.date)
                      : ''
                  }
                  onChange={this.dateDidChange}
                />
                <span className="text-danger">
                  Bez zadaného dátumu článok nie je publikovaný
                </span>
              </div>

              <div className="form-group">
                <label className="title">Publikovať na URL</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={
                    this.props.article.url || this.props.article.urlSuggestion
                      ? ''
                      : 'Zadajte relatívnu URL'
                  }
                  value={
                    this.props.article.url ||
                    this.props.article.urlSuggestion ||
                    ''
                  }
                  onChange={this.urlDidChange}
                />
              </div>

              <div className="form-group">
                <label className="title">Priorita</label>
                <div className="row">
                  <div className="col-sm-4">
                    <strong>Titulka</strong>
                    <input
                      type="text"
                      className="form-control"
                      name="pin2top"
                      value={
                        this.props.article.pin2top
                          ? parseInt(this.props.article.pin2top)
                          : ''
                      }
                      onChange={this.pinDidChange}
                    />
                  </div>
                  <div className="col-sm-4">
                    <strong>Lokalita</strong>
                    <input
                      type="text"
                      className="form-control"
                      name="pin2locality"
                      value={this.props.article.pin2locality || ''}
                      onChange={this.pinDidChange}
                    />
                  </div>
                  <div className="col-sm-4">
                    <strong>Kategória</strong>
                    <input
                      type="text"
                      className="form-control"
                      name="pin2category"
                      value={this.props.article.pin2category || ''}
                      onChange={this.pinDidChange}
                    />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label className="title">Autor článku</label>
                <input
                  className="form-control"
                  onChange={this.authorNameDidChange}
                  type="text"
                  value={v(this.props.article.author, 'name', '')}
                  placeholder=""
                />
              </div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={!!this.props.article.push_notification}
                      name="perexHidden"
                      onChange={this.pushNotificationDidChange}
                    />
                    Odoslať PUSH notifikáciu
                  </label>
                </div>
              </div>

              <div className="form-group text-center">
                {(() => {
                  const p = v(this.props.article.author, 'picture', null);
                  if (p) {
                    return (
                      <div>
                        <a
                          href="javascript:void();"
                          onClick={this.openMediaBrowserAuthorPicture}
                        >
                          <img
                            src={
                              'https://data.tvkosice.sk/images/cm/168x168xmedia/' +
                              p
                            }
                            style={{
                              maxWidth: '30%',
                              borderRadius: '100%',
                              border: '1px solid black',
                            }}
                          />
                        </a>
                        <br />
                        <button
                          className="btn btn-sm btn-link text-danger"
                          onClick={this.removeAuthorPicture}
                        >
                          Odobrať fotku
                        </button>
                      </div>
                    );
                  } else {
                    return (
                      <button
                        className="btn btn-sm btn-link"
                        onClick={this.openMediaBrowserAuthorPicture}
                      >
                        Priradiť fotku
                      </button>
                    );
                  }
                })()}
              </div>

              {this.props.article.locked &&
              !this.props.contentspace_info.is_contentspace_admin ? null : (
                <div className="form-group">
                  <div className="row">
                    {this.props.article._id ? (
                      <div className="col-xs-6">
                        <button
                          onClick={this.articleShouldRemove}
                          className="btn btn-danger btn-block"
                        >
                          <i className="fa fa-trash" /> Odstrániť
                        </button>
                      </div>
                    ) : null}
                    <div
                      className={`col-xs-${this.props.article._id ? 6 : 12}`}
                    >
                      <button
                        onClick={this.props.articleDidSave}
                        className="btn btn-success btn-block"
                      >
                        <i className="fa fa-floppy-o" /> Uložiť
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div className="form-group">
                <div className="row">
                  <div className="col-md-12">
                    <button
                      onClick={this.props.articleDidPreview}
                      className="btn btn-default btn-sm btn-block"
                    >
                      <i className="fa fa-search" /> Náhľad článku
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {sectionForm}
        </div>
      );
    }
  }
}

export default ArticlePublicationForm;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticlePublicationForm.jsx